import axiosClient from "./axiosClient";
import https from "https";

import ConstData from "../ConstData";

let options = {};

if (ConstData.IS_LOCAL_VERSION) {
    options = {
        httpsAgent: new https.Agent({
            rejectUnauthorized: false, // 허가되지 않은 인증을 reject하지 않겠다!
        })
    }
}

// 클래스 멤버 리스트 가져오기
export const get_live_member_list = ({ liveSeq }) => {
    console.log(`get_live_member_list - liveSeq[${liveSeq}]`);

    return axiosClient.get(`/live/member/${liveSeq}`, options);
}

// 클래스 삭제
// 20260828: 완전 삭제(DELETE) 대신 서비스에서 사용 여부(USE_YN)를 'N'으로 처리 - 프론트는 그대로 remove 요청만 보내면 됨
export const remove_live = ({ mode, liveSeq, userSeq }) => {
    console.log("api remove live:) mode[", mode, "], liveSeq[", liveSeq, "], userSeq[", userSeq, "]");

    return axiosClient.delete(`/live/${liveSeq}/${userSeq}?kind=remove&mode=${mode}`, options);
}

// 클래스 이름 변경
export const update_live_name = ({ mode, liveSeq, userSeq, liveName }) => {
    console.log("api update live name:) mode[", mode, "], liveSeq[", liveSeq, "], userSeq[", userSeq, "], liveName[", liveName, "]");

    return axiosClient.put(`/live/${liveSeq}/${userSeq}?kind=edit-name&mode=${mode}`, {
        liveName
    }, options);
}

// 클래스 그룹 연결 인원 변경
export const update_live_group_limit = ({ userSeq, groupLimit, liveSeqArr }) => {
    console.log("api update live group limit:) userSeq[", userSeq, "], groupLimit[", groupLimit, "], liveSeqArr => ", liveSeqArr);

    return axiosClient.put(`/live/${userSeq}?kind=edit-groupLimit`, {
        liveSEQList: liveSeqArr,
        groupLimit
    }, options);
}

// 클래스 방송 알림
export const notify_live_broadcast = ({ mode, liveSeq, userSeq, data }) => {
    console.log("api notify live broadcast:) mode[", mode, "], liveSeq[", liveSeq, "], userSeq[", userSeq, "], data => ", data);

    return axiosClient.put(`/live/${liveSeq}/${userSeq}?kind=notify-broadcast&mode=${mode}`, {
        startDate: data.startDate,
        endDate: data.endDate
    }, options);
}

export const notify_live_broadcast_with_guest = ({ mode, liveSeq, userSeq, data }) => {
    console.log("api notify live broadcast with guest:) mode[", mode, "], liveSeq[", liveSeq, "], userSeq[", userSeq, "], data => ", data);

    return axiosClient.put(`/live/${liveSeq}/${userSeq}?kind=notify-broadcast&mode=${mode}`, {
        startDate: data.startDate,
        endDate: data.endDate,
        list_guest: data.list_guest
    }, options);
}

// 클래스 방송 오픈
export const live_on = ({ mode, liveSeq, userSeq, groupLimit, studioSeq, isChattingLock, isTouchScreenLock, liveTeacherNickname }) => {
    console.log("api live on:) mode[", mode, "], liveSeq[", liveSeq, "], userSeq[", userSeq, "]");
    console.log("api live on:) groupLimit[", groupLimit, "], studioSeq[", studioSeq, "]");
    console.log("api live on:) isChattingLock[", isChattingLock, "], isTouchScreenLock[", isTouchScreenLock, "]");
    console.log("api live on:) liveTeacherNickname[", liveTeacherNickname, "]");

    let data = { liveStatus: "Y" };
    if (groupLimit !== undefined && groupLimit !== null) {
        data.groupLimit = groupLimit;
    }

    if (studioSeq !== undefined && studioSeq !== null) {
        data.studioSEQ = studioSeq;
    }

    if (isChattingLock !== undefined && isChattingLock !== null) {
        data.isChattingLock = isChattingLock;
    }

    if (isTouchScreenLock !== undefined && isTouchScreenLock !== null) {
        data.isTouchScreenLock = isTouchScreenLock;
    }

    if (liveTeacherNickname !== undefined && liveTeacherNickname !== null && liveTeacherNickname !== "") {
        data.liveTeacherNickname = liveTeacherNickname;
    }

    /* if (groupLimit !== undefined && groupLimit !== null) {
        console.log("api live on:) case (1)");
        return axiosClient.put(`/live/${liveSeq}/${userSeq}?kind=update-status&mode=${mode}`, {
            liveStatus: "Y",
            groupLimit
        });
    } else {
        console.log("api live on:) case (2)");
        return axiosClient.put(`/live/${liveSeq}/${userSeq}?kind=update-status&mode=${mode}`, {
            liveStatus: "Y"
        });
    } */

    return axiosClient.put(`/live/${liveSeq}/${userSeq}?kind=update-status&mode=${mode}`, data, options);
}

// 클래스 방송 닫음
export const live_off = ({ mode, liveSeq, userSeq }) => {
    console.log("api live off:) mode[", mode, "], liveSeq[", liveSeq, "], userSeq[", userSeq, "]");

    return axiosClient.put(`/live/${liveSeq}/${userSeq}?kind=update-status&mode=${mode}`, {
        liveStatus: "N"
    }, options);
}

// 클래스 생성
export const create_live = ({ mode, teacherSeq, liveName, liveCode, robotLiveYN }) => {
    console.log("api create live:) mode[", mode, "], teacherSeq[", teacherSeq, "]");
    console.log("api create live:) liveName[", liveName, "], liveCode[", liveCode, "], robotLiveYN[", robotLiveYN, "]");

    return axiosClient.post(`/live?kind=create&mode=${mode}`, {
        teacherSEQ: teacherSeq,
        liveName,
        liveCode,
        robotLiveYN: robotLiveYN === undefined || robotLiveYN === null ? "N" : robotLiveYN
    }, options);
}

// 클래스 멤버 허가 & 거절
export const update_live_member = ({ mode, liveSeq, userSeq, liveCertiYN }) => {
    console.log("api update live member:) mode[", mode, "], liveSeq[", liveSeq, "], userSeq[", userSeq, "], liveCertiYN[", liveCertiYN, "]");

    return axiosClient.put(`/live/${liveSeq}/${userSeq}?kind=update-member&mode=${mode}`, {
        liveCertiYN
    }, options);
}

// 클래스 멤버 삭제
export const remove_live_member = ({ mode, liveSeq, userSeq }) => {
    console.log("api remove live member:) mode[", mode, "], liveSeq[", liveSeq, "], userSeq[", userSeq, "]");

    return axiosClient.put(`/live/${liveSeq}/${userSeq}?kind=remove-member&mode=${mode}`, {
        liveCertiYN: "N"
    }, options);
}

// 클래스 코드 생성
export const create_code = ({ mode }) => {
    console.log("api create code:) mode[", mode, "]");

    /* return axiosClient.put(`/live/code?kind=create-code&mode=${mode}`, {
        liveCode: null
    }); */

    return axiosClient.get(`/live/code?kind=create-code`, options);
}

// 클래스 코드 중복 확인
export const check_code = ({ mode, liveCode }) => {
    console.log("api check code:) mode[", mode, "], liveCode[", liveCode, "]");

    /* return axiosClient.put(`/live/code?kind=check-code&mode=${mode}`, {
        liveCode
    }); */

    return axiosClient.get(`/live/code?kind=check-code&liveCode=${liveCode}`, options);
}

// 클래스 코드 인증
export const certify_code = ({ mode, userSeq, liveCode }) => {
    console.log("api certify code:) mode[", mode, "], userSeq[", userSeq, "], liveCode[", liveCode, "]");

    /* return axiosClient.put(`/live/code?kind=certify-code&mode=${mode}`, {
        liveCode,
        userSEQ: userSeq
    }); */

    return axiosClient.put(`/live/code?kind=certify-code`, {
        liveCode,
        userSEQ: userSeq
    }, options);
}

// 클래스 신청
export const apply_live = ({ mode, liveSeq, userSeq }) => {
    console.log("api apply live:) mode[", mode, "], liveSeq[", liveSeq, "], userSeq[", userSeq, "]");

    return axiosClient.post(`/live/${liveSeq}/${userSeq}?kind=apply&mode=${mode}`, {}, options);
}

// 클래스 재신청
export const reapply_live = ({ mode, liveSeq, userSeq }) => {
    console.log("api reapply live:) mode[", mode, "], liveSeq[", liveSeq, "], userSeq[", userSeq, "]");

    return axiosClient.post(`/live/${liveSeq}/${userSeq}?kind=reapply&mode=${mode}`, {}, options);
}

// 내가 선생님인 클래스 리스트
export const get_my_live_list = ({ mode, userSeq }) => {
    console.log("api get my live list:) mode[", mode, "], userSeq[", userSeq, "]");

    return axiosClient.get(`/live/${userSeq}?kind=teacher&mode=${mode}`, options);
}

// 내가 학생인 클래스 리스트
export const get_my_watch_live_list = ({ mode, userSeq }) => {
    console.log("api get my watch live list:) mode[", mode, "], userSeq[", userSeq, "]");

    return axiosClient.get(`/live/${userSeq}?kind=student&mode=${mode}`, options);
}

// 클래스 클래스 입장
export const join_live = ({ liveSeq, userSeq, userNickname, mixedClassSeq }) => {
    console.log("api join live:) liveSeq[", liveSeq, "], userSeq[", userSeq, "], userNickname[", userNickname, "], mixedClassSeq[", mixedClassSeq, "]");

    return axiosClient.post(`/live/join/${liveSeq}/${userSeq}?kind=join&mode=web`, {
        userNickname
    }, options);
}

// 클래스 클래스 나가기
export const finish_live = ({ liveSeq, userSeq, mixedClassSeq, serverUserSeq }) => {
    console.log("api finish live:) liveSeq[", liveSeq, "], userSeq[", userSeq, "], mixedClassSeq[", mixedClassSeq, "], serverUserSeq[", serverUserSeq, "]");

    return axiosClient.delete(`/live/${liveSeq}/${userSeq}?kind=finish&mode=web`, options);
}

// 믹스드 클래스 클래스 입장 요청
export const request_join_mixed_class_live = ({ liveSeq, userSeq, userNickname, mixedClassSeq }) => {
    console.log("api request join mixed class live:) liveSeq[", liveSeq, "], userSeq[", userSeq, "], mixedClassSeq[", mixedClassSeq, "], userNickname[", userNickname, "]");

    return axiosClient.post(`/live/join/${liveSeq}/${userSeq}?kind=mixed-join&mode=web&mixedClassSEQ=${mixedClassSeq}`, {
        userNickname
    }, options);
}

// 믹스드 클래스 클래스 나가기 요청
export const request_finish_mixed_class_live = ({ liveSeq, userSeq, mixedClassSeq }) => {
    console.log("api request finish mixed class live:) liveSeq[", liveSeq, "], userSeq[", userSeq, "], mixedClassSeq[", mixedClassSeq, "]");

    return axiosClient.delete(`/live/${liveSeq}/${userSeq}?kind=mixed-finish&mode=web&mixedClassSEQ=${mixedClassSeq}`, options);
}

// 클래스 방송 시작
export const start_live = ({ userSeq }) => {
    console.log("api start live:) userSeq[", userSeq, "]");

    return axiosClient.put(`/live/${userSeq}?kind=start`, {}, options);
}

// 클래스 방송 멈춤
export const stop_live = ({ userSeq }) => {
    // console.log("api stop live:) userSeq[", userSeq, "]");

    return axiosClient.put(`/live/${userSeq}?kind=stop`, {}, options);
}

// hands up image 1초에 한번씩 보내기
export const send_handsup_image = ({ liveSeq, teacherSeq, userSeq, groupSendKey, data, filename }) => {
    // console.log("api send handsup image:) liveSeq[", liveSeq, "], teacherSeq[", teacherSeq, "], userSeq[", userSeq, "], groupSendKey[", groupSendKey, "]");

    if (liveSeq >= 0 && teacherSeq >= 0 && userSeq >= 0) {
        const form = new FormData();
        form.append("image", data, filename);
        form.append("groupSendKey", groupSendKey);

        return axiosClient.post(`/handsup/${liveSeq}/${teacherSeq}/${userSeq}`, form, options);
    }
}

export const change_handsup_active_status = ({ liveSeq, userSeq, studioSeq, activeYN }) => {
    console.log("api get change handsup active status:) liveSeq[", liveSeq, "], userSeq[", userSeq, "], studioSeq[", studioSeq, "], activeYN[", activeYN, "]");

    let data = { userSEQ: userSeq };
    if (studioSeq !== undefined && studioSeq !== null) {
        data.studioSEQ = studioSeq;
    }

    return axiosClient.put(`/handsup/${liveSeq}?kind=active&activeKind=${activeYN}`, data, options);
}

// broadcast oepn
export const broadcast_open = ({ liveSeq, userSeq, broadcastSeq, groupLimit }) => {
    console.log("api broadcast open:) liveSeq[", liveSeq, "], userSeq[", userSeq, "], broadcastSeq[", broadcastSeq, "], groupLimit[", groupLimit, "]");

    return axiosClient.put(`/live/broadcast?kind=open`, {
        broadcastSEQ: broadcastSeq,
        liveSEQ: liveSeq
    }, options);
}

// QR 로그인 시, 클래스 멤버 목록 가져오는 API 
export const get_live_member_list_by_qr_login = ({ mode, liveSeq }) => {
    console.log("api get live member list by qr login:) mode[", mode, "], liveSeq[", liveSeq, "]");

    let protocol = window.location.protocol;
    console.log("api get live member list by qr login:) protocol[", protocol, "]");

    if (ConstData.IS_LOCAL_VERSION && protocol === "http:") {
        let newRestApiUrl = ConstData.REST_API_HOST_ADD;
        newRestApiUrl = newRestApiUrl.replace("https:", "http:");
        newRestApiUrl = newRestApiUrl.replace(":8001", ":8000");
        console.log(`newRestApiUrl[${newRestApiUrl}], REST_API_HOST_ADD[${ConstData.REST_API_HOST_ADD}]`);

        // return axiosClient.get(`${newRestApiUrl}/live/${liveSeq}?kind=qr-login&mode=${mode}`, options);
        return axiosClient.get(`/live/${liveSeq}?kind=qr-login&mode=${mode}`, options);
    } else {
        return axiosClient.get(`/live/${liveSeq}?kind=qr-login&mode=${mode}`, options);
    }
}

export const get_live_info_by_cookies = ({ mode, liveSeq }) => {
    console.log("api get live info by cookies:) mode[", mode, "], liveSeq[", liveSeq, "]");

    return axiosClient.get(`/live/${liveSeq}?kind=cookies-login&mode=${mode}`, options);
}

export const notify_logout_to_login_live_members = ({ liveSeq, userSeq }) => {
    console.log("api notify logout to login live members:) liveSeq[", liveSeq, "], userSeq[", userSeq, "]");

    return axiosClient.put(`/live-logout/${liveSeq}/${userSeq}`);
}

// ********************************************************************************** //

// 20261022 같은 라이브 페이지 끊김 복구 후 서버 입장 기록 복원 (web-relay R-173)
// 20261023 timeoutMs: 이 요청만의 응답 대기 상한(공용 axios 기본값은 그대로, R-180)
export const rejoin_live = ({ liveSeq, userSeq, userNickname }, timeoutMs) => {
    console.log("api rejoin live:) liveSeq[", liveSeq, "], userSeq[", userSeq, "]");

    return axiosClient.post(`/live/rejoin/${liveSeq}/${userSeq}`, {
        userNickname
    }, timeoutMs > 0 ? { ...options, timeout: timeoutMs } : options);
}
